module.exports = "/_next/static/images/georgia-13f14edec51b19676a7a915fdd76c18e.svg";